module.exports = __webpack_public_path__ + "img/plus.6139fab6.svg";